/**
 * Internal-only UI switch. Parts of the product that are hidden from
 * customers for now (subscription and configuration sections, clause
 * templates, connected contracts, Manage Providers, Reindex, Subscription & Usage, License
 * Management, and the plan-expiry banner) come back when this returns true.
 * The Obligation Tracker and the Receivables Recovery have switches of their own
 * (utils/emeisModuleFlags).
 *
 * Off by default. Turn it on from the browser console and reload:
 *
 *   localStorage.setItem("isEmeis", "true")
 *
 * and off again with localStorage.removeItem("isEmeis").
 */
export const EMEIS_FLAG_KEY = "isEmeis";

export function isEmeisEnabled(): boolean {
  try {
    return localStorage.getItem(EMEIS_FLAG_KEY) === "true";
  } catch {
    return false;
  }
}
